const lenis = new Lenis();

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

window.addEventListener("load", () => {
  ScrollTrigger.refresh();

  if (typeof lenis !== "undefined" && lenis.update) {
    lenis.update();
  }
});

// IntersectionObserver (in view detection)
const observer = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        $item = entry.target;
        $item.classList.add("in-view");
      }
    });
  },
  {
    root: null,
    threshold: 0,
    rootMargin: "0px 0px -10% 0px",
  },
);

window.onload = () => {
  document.querySelectorAll("h1, h2, .fade-in, .fade-in-wrapper > *").forEach((el) => observer.observe(el));
};

// headroom
var header = document.querySelector(".header");
var headroom = new Headroom(header, {
  offset: header.clientHeight,
});
headroom.init();

// mobile menu
let wasPinned = false;
function navClose() {
  document.querySelector(".navbar-toggler").classList.remove("active");
  document.querySelector(".header").classList.remove("nav-opened");
  document.querySelector(".header__nav").classList.remove("active");
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      headroom.unfreeze();
    });
  });
}

function navOpen() {
  headroom.freeze();
  document.querySelector(".navbar-toggler").classList.add("active");
  document.querySelector(".header").classList.add("nav-opened");
  document.querySelector(".header__nav").classList.add("active");
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelector(".header .navbar-toggler").addEventListener("click", function () {
    this.classList.contains("active") ? navClose() : navOpen();
  });
});

// anchors — handles both #hash and /#hash formats (WP nav menus output /#hash)
const anchorLinks = document.querySelectorAll('.link[href^="#"], .link[href^="/#"], .footer__nav a[href^="#"], .footer__nav a[href^="/#"]');
const navLinks = document.querySelectorAll('.header__nav .link[href^="#"], .header__nav .link[href^="/#"]');
const sections = document.querySelectorAll("section[id]");

function getHashFromHref(href) {
  if (href.startsWith("/#")) return href.substring(1);
  return href;
}

anchorLinks.forEach((link) => {
  link.addEventListener("click", function (e) {
    e.preventDefault();

    const isInNav = this.closest(".header__nav");

    if (isInNav) {
      navClose();

      navLinks.forEach((l) => l.classList.remove("current"));
      this.classList.add("current");
    }

    const targetId = getHashFromHref(this.getAttribute("href"));
    const target = document.querySelector(targetId);

    if (!target) return;

    const delay = isInNav ? 300 : 0;

    setTimeout(() => {
      lenis.scrollTo(target, {
        duration: 1.2,
      });
    }, delay);
  });
});

const observerNav = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const id = entry.target.id;

      navLinks.forEach((link) => {
        const linkHash = getHashFromHref(link.getAttribute("href"));
        link.classList.toggle("current", linkHash === `#${id}`);
      });
    });
  },
  {
    rootMargin: "-30% 0px -70% 0px",
    threshold: 0,
  },
);

sections.forEach((section) => observerNav.observe(section));

// open calendar — Calendly widget is loaded via footer-scripts.php
// This block is intentionally empty; the click handler is registered in the PHP template
// to ensure the calendly_url from ACF options is used dynamically.

// slideshow
const NEXT = 1;

class Slideshow {
  constructor(el) {
    this.DOM = {
      el: el,
      slides: [...el.querySelectorAll(".slide")],
      slidesInner: [],
      deco: el.querySelector(".deco"),
    };

    this.DOM.slidesInner = this.DOM.slides.map((slide) => slide.querySelector(".slide__img"));

    this.current = 0;
    this.slidesTotal = this.DOM.slides.length;
    this.isAnimating = false;

    this.DOM.slides[this.current].classList.add("slide--current");

    this.startAutoplay();
  }

  next() {
    this.navigate(NEXT);
  }

  navigate(direction) {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const previous = this.current;

    this.current = this.current < this.slidesTotal - 1 ? this.current + 1 : 0;

    const currentSlide = this.DOM.slides[previous];
    const currentInner = this.DOM.slidesInner[previous];
    const upcomingSlide = this.DOM.slides[this.current];
    const upcomingInner = this.DOM.slidesInner[this.current];

    gsap
      .timeline({
        defaults: { duration: 1.3 },
        onComplete: () => {
          currentSlide.classList.remove("slide--current");
          upcomingSlide.classList.add("slide--current");
          this.isAnimating = false;
        },
      })
      .addLabel("start", 0)
      .to(
        currentSlide,
        {
          duration: 0.4,
          ease: "power2.in",
          yPercent: -100,
        },
        "start",
      )
      .to(
        currentInner,
        {
          duration: 0.4,
          ease: "power2.in",
          yPercent: 75,
          rotation: -2,
        },
        "start",
      )
      .fromTo(
        this.DOM.deco,
        {
          yPercent: 100,
          autoAlpha: 1,
        },
        {
          duration: 0.4,
          ease: "power2.in",
          yPercent: 0,
        },
        "start",
      )

      .addLabel("middle", "start+=0.5")
      .to(
        this.DOM.deco,
        {
          ease: "expo",
          yPercent: -100,
        },
        "middle",
      )
      .fromTo(
        upcomingSlide,
        {
          autoAlpha: 1,
          yPercent: 100,
        },
        {
          ease: "expo",
          yPercent: 0,
        },
        "middle",
      )
      .fromTo(
        upcomingInner,
        {
          yPercent: -75,
          rotation: 2,
        },
        {
          ease: "expo",
          yPercent: 0,
          rotation: 0,
        },
        "middle",
      );
  }

  startAutoplay() {
    setInterval(() => {
      this.next();
    }, 6000);
  }
}

// init
document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector(".slides");
  if (el) new Slideshow(el);
});

// headlines animation
CustomEase.create("elastic-css", ".2, 1.33, .25 ,1");

function initSplitText() {
  document.querySelectorAll("h1, h2").forEach((heading) => {
    if (heading.closest(".terms-header") || heading.closest(".error-404")) return;
    // split per heading
    const split = new SplitText(heading, {
      type: "words",
      wordsClass: "single-word",
    });

    // wrap each word
    heading.querySelectorAll(".single-word").forEach((el) => {
      const wrapper = document.createElement("div");
      wrapper.className = "single-word-inner";

      while (el.firstChild) {
        wrapper.appendChild(el.firstChild);
      }

      el.appendChild(wrapper);
    });

    // animate on scroll
    gsap.to(heading.querySelectorAll(".single-word-inner"), {
      y: 0,
      rotate: 0.001,
      stagger: 0.05,
      duration: 1,
      ease: "elastic-css",
      scrollTrigger: {
        trigger: heading,
        start: "top 80%",
      },
    });
  });
}

initSplitText();

// offers
const list = document.querySelector(".offers__list");
let items = Array.from(list.querySelectorAll(".offers__list-item"));

let currentMode = null;

function getMode() {
  return window.innerWidth < 768 ? 2 : 4;
}

function unwrap() {
  const rows = list.querySelectorAll(".offers__list-row");
  rows.forEach((row) => {
    while (row.firstChild) {
      list.appendChild(row.firstChild);
    }
    row.remove();
  });
}

function wrap() {
  const perRow = getMode();

  const newItems = Array.from(list.querySelectorAll(".offers__list-item"));

  for (let i = 0; i < newItems.length; i += perRow) {
    const row = document.createElement("div");
    row.className = "offers__list-row fade-in";

    newItems.slice(i, i + perRow).forEach((item) => {
      row.appendChild(item);
    });

    list.appendChild(row);
  }
}

function rebuild() {
  const mode = getMode();

  if (mode === currentMode) return;

  currentMode = mode;

  unwrap();
  wrap();

  ScrollTrigger.refresh();

  document.querySelectorAll(".offers__list-row").forEach((el) => observer.observe(el));

  window.dispatchEvent(new Event("resize"));
}

rebuild();

window.addEventListener("resize", () => {
  clearTimeout(window._wrapTimer);
  window._wrapTimer = setTimeout(rebuild, 150);
});

// parallax
let parallaxAmount = window.innerHeight * 0.02;
if (window.innerWidth < 1080) {
  parallaxAmount = window.innerHeight * 0.01;
}
document.querySelectorAll(".img-parallax").forEach((parallax) => {
  gsap.to(parallax.querySelector("img"), {
    y: parallaxAmount,
    scrollTrigger: {
      trigger: parallax,
      start: "top bottom",
      end: "bottom top",
      scrub: 1,
    },
  });
});

// brands slider
const brandsSliderOptions = {
  loop: true,
  speed: 3500,
  spaceBetween: 8,
  slidesPerView: "auto",
  freeMode: true,
  slideToClickedSlide: false,
  preventClicks: true,
  preventClicksPropagation: true,
  breakpoints: {
    768: {
      speed: 5000,
      spaceBetween: 10,
    },
  },
  on: {
    init: function () {
      ScrollTrigger.refresh();
    },
  },
};
document.querySelectorAll(".brands__slider .swiper").forEach((slider) => {
  if (slider.classList.contains("swiper-ltr")) {
    new Swiper(slider, {
      ...brandsSliderOptions,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
  } else {
    new Swiper(slider, {
      ...brandsSliderOptions,
      autoplay: {
        delay: 0,
        reverseDirection: true,
        disableOnInteraction: false,
      },
    });
  }
});

// text chars animation
const elements = document.querySelectorAll(".text-animated");

elements.forEach((el) => {
  const split = new SplitText(el, { type: "words, chars" });

  gsap.set(split.chars, {
    color: "rgba(141, 63, 28, 0.3)",
  });

  gsap.to(split.chars, {
    color: "rgba(141, 63, 28, 1)",
    stagger: 0.1,
    scrollTrigger: {
      trigger: el,
      start: "top 80%",
      end: "top 30%",
      scrub: true,
    },
  });
});

// testimonials slider
new Swiper(".showroom__slider .swiper", {
  loop: true,
  spaceBetween: 12,
  slidesPerView: "auto",
  navigation: {
    prevEl: ".showroom__slider .swiper-button-prev",
    nextEl: ".showroom__slider .swiper-button-next",
  },
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      spaceBetween: 20,
    },
    1080: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
  on: {
    init: () => {
      ScrollTrigger.refresh();
    },
  },
});

// Gravity Forms placeholder select styling
function initGravityFormPlaceholders() {
  const selects = document.querySelectorAll('.gfield_select, .gform_wrapper select');

  function updatePlaceholderClass(select) {
    
    // Safely access the selected option
    if (!select.options || select.selectedIndex < 0) {
      select.classList.remove('is-placeholder');
      return;
    }

    const selectedOption = select.options[select.selectedIndex];
    
    if (!selectedOption) {
      select.classList.remove('is-placeholder');
      return;
    }

    // Check for placeholder indicators
    const hasPlaceholderClass = selectedOption.classList.contains('gf_placeholder');
    const hasEmptyValue = selectedOption.value === '';
    const isUndefined = selectedOption.value === undefined;
    
    const isPlaceholder = hasPlaceholderClass || hasEmptyValue || isUndefined;

    if (isPlaceholder) {
      select.classList.add('is-placeholder');
    } else {
      select.classList.remove('is-placeholder');
    }
  }

  selects.forEach(select => {
    updatePlaceholderClass(select);

    // Check on change
    select.addEventListener('change', function() {
      updatePlaceholderClass(this);
    });
  });
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  initGravityFormPlaceholders();
});

// Also run after a delay in case Gravity Forms loads async
setTimeout(() => {
  initGravityFormPlaceholders();
}, 500);
